import { KEYS } from 'app/constants/SceneConstants';
import ShortcutController from '../shortcuts/ShortcutController';
import GamePlay from './GamePlay';

export default class CombatTest extends GamePlay {
  constructor() {
    super({ key: KEYS.CombatTest, active: false });
  }

  init(config) {
    this._leveldata = { heroid: 'beastboy' };
    this._stageConfig = {
      mapid: 'combattest',
    };
  }

  preload() {
    if (!this.cache.json.get('combattest')) {
      this.load.json('combattest', 'assets/maps/combattest.json');
    }
  }

  create() {
    super.create();
    this.game.setShortcuts(ShortcutController.STATES.COMBAT_TEST);
    // this.game.hud.setState('EMPTY');

    // if (__WATCH__) this.spawnBoss('FOREMAN');
    // if (__WATCH__) this.spawnEnemy('skeleton');
    this._state = GamePlay.STATES.FIGHTING;
  }

  spawnHero(heroid) {
    this._hero.changeHero(this.game.model.getHeroConfig(heroid));
  }

  spawnEnemy(enemyid) {
    this._enemyController.clearEnemies();
    // this._enemyHealth.target = this._enemyController.spawnEnemy(enemyid, 1200, 600);
    this._spawnEnemy = enemyid;
  }

  spawnBoss(bossid) {
    this._spawnBoss = bossid;
    // this._enemyController.clearEnemies();
    // this._enemyController.clearBoss();
    // this._enemyController.spawnBoss(bossid, this.viewport);
  }

  update(time, delta) {
    super.update(time, delta);
    if (this._spawnBoss) {
      // this._enemyController.clearEnemies();
      this._enemyController.clearBoss();
      this._enemyController.spawnBoss(this._spawnBoss, this.viewport);
      this._spawnBoss = null;
      return;
    }

    if (this._spawnEnemy) {
      this._enemyController.spawnEnemy(this._spawnEnemy, 1200, 600);
      this._spawnEnemy = null;
    }
  }

  failLevel() {}
  completeLevel() {}

  showStage() {
    this.start();
  }

  shutdown() {
    this._spawnEnemy = null;
    this._spawnBoss = null;
  }
}
